export const sampleDeliveryAction= (data) => { 
  return {
     type: data.type,
     data:data.data
  }
}